<div>
  <!-- Toolbar -->
  @if(hasFilter && elements.length > 0) {
    <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
      <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" [(ngModel)]="globalFilter" placeholder="Búsqueda rápida" class="w-full md:w-80" />
      </p-iconfield>

      @if(hasDownload) {
        <div class="flex gap-2">
          @if(downloadOptions.length <= 3) {
            @for(opt of downloadOptions; track opt.value) {
              <button pButton [label]="opt.text" class="p-button-sm p-button-outlined" (click)="onDownload(opt.value)"></button>
            }
          } @else {
            <div class="relative">
              <button pButton label="Descargar" icon="pi pi-download" class="p-button-sm p-button-outlined" (click)="showDownloadMenu = !showDownloadMenu"></button>
              @if(showDownloadMenu) {
                <div class="absolute right-0 top-full mt-1 bg-white dark:bg-crayola-blue-800 border border-dark-khaki-200 dark:border-vivid-royal-700 rounded-lg shadow-lg z-20 min-w-[180px]">
                  @for(opt of downloadOptions; track opt.value) {
                    <button type="button" class="w-full px-4 py-2 text-sm text-left hover:bg-dark-khaki-100 dark:hover:bg-vivid-royal-800"
                      (click)="onDownload(opt.value); showDownloadMenu = false">{{ opt.text }}</button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Desktop Table -->
  <div class="hidden md:block">
    <p-table
      #dt
      [value]="tableData"
      [paginator]="tableData.length > rowsByPage"
      [rows]="rowsByPage"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [globalFilterFields]="filterFields"
      [filterDelay]="300"
      [scrollable]="true"
      scrollHeight="flex"
      [tableStyle]="{'min-width': '60rem'}"
      styleClass="p-datatable-sm p-datatable-striped"
      [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'"
      [showCurrentPageReport]="true"
    >
      <ng-template #header>
        <tr>
          @if(hasButton) {
            <th class="w-[120px]">Acciones</th>
          }
          @for(col of visibleHeaders; track col.key) {
            <th [pSortableColumn]="col.key">
              {{ col.textHeader }}
              <p-sortIcon [field]="col.key" />
            </th>
          }
        </tr>
        <!-- Filter row -->
        @if(hasColumnFilter) {
        <tr>
          @if(hasButton) { <th></th> }
          @for(col of visibleHeaders; track col.key) {
            <th>
              <input pInputText type="text" [placeholder]="'Filtrar'" (input)="dt.filter($any($event.target).value, col.key, 'contains')" class="w-full p-1 text-sm" />
            </th>
          }
        </tr>
        }
      </ng-template>

      <ng-template #body let-item>
        <tr>
          @if(hasButton) {
            <td>
              <div class="flex gap-1 flex-wrap">
                @for(btn of actions; track btn.text) {
                  @if(item['buttons']) {
                    @for(ib of item['buttons']; track ib; let i = $index) {
                      @if(ib === btn.text) {
                        <app-custom-table-button
                          [showButtonText]="btn.showText"
                          [color]="(item.colors && item.colors[i]) ? item.colors[i] : btn.color"
                          [textButton]="btn.text"
                          [hasIcon]="btn.hasIcon"
                          [icon]="btn.icon"
                          (onClick)="btn.action(item)"
                        ></app-custom-table-button>
                      }
                    }
                  } @else {
                    @if(!item.disableButton) {
                      <app-custom-table-button
                        [showButtonText]="btn.showText"
                        [color]="btn.color"
                        [textButton]="btn.text"
                        [hasIcon]="btn.hasIcon"
                        [icon]="btn.icon"
                        (onClick)="btn.action(item)"
                      ></app-custom-table-button>
                    }
                  }
                }
              </div>
            </td>
          }
          @for(col of visibleHeaders; track col.key) {
            <td>
              @if(col.type === 'status' && showStatus) {
                <span class="p-2 rounded-sm shadow-sm" [ngClass]="generateClass(item[col.key])">
                  {{ item[col.key] }}
                </span>
              } @else if(col.type === 'date') {
                {{ item[col.key] | date:'dd/MM/YYYY' }}
              } @else if(col.type === 'fullTime') {
                {{ item[col.key] | date:'dd/MM/YYYY hh:mm a' }}
              } @else if(col.type === 'currency') {
                {{ item[col.key] | currency }}
              } @else if(col.type === 'liters') {
                {{ item[col.key] }} Lts
              } @else if(col.type === 'html') {
                <p [innerHTML]="item[col.key] | parserHtml"></p>
              } @else {
                {{ item[col.key] }}
              }
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="visibleHeaders.length + (hasButton ? 1 : 0)" class="text-center py-6">
            {{ emptyTableMessage }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Cards -->
  <div class="block md:hidden space-y-3">
    @for(item of tableData; track $index) {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-2">
        @for(col of visibleHeaders; track col.key) {
          <div class="flex justify-between text-sm">
            <span class="font-semibold text-vivid-royal-700 dark:text-vivid-royal-200">{{ col.textHeader }}</span>
            <span class="text-right text-vivid-royal-900 dark:text-white">
              @if(col.type === 'date') {
                {{ item[col.key] | date:'dd/MM/YYYY' }}
              } @else if(col.type === 'currency') {
                {{ item[col.key] | currency }}
              } @else {
                {{ item[col.key] }}
              }
            </span>
          </div>
        }
        @if(hasButton) {
          <div class="flex flex-wrap gap-2 pt-2 border-t border-dark-khaki-200 dark:border-vivid-royal-700">
            @for(btn of actions; track btn.text) {
              @if(!item.disableButton) {
                <button pButton [label]="btn.text" class="p-button-sm p-button-outlined" (click)="btn.action(item)"></button>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</div>
